import { types } from "mobx-state-tree"
import PaginationOptions from './PaginationOptions'

const AccountInventoryLocationsUIStore = types.compose(
    PaginationOptions,
    types.model({

    })
)

export default AccountInventoryLocationsUIStore.create({
    rowsPerPage: 10,
    page: 0
})


// WEBPACK FOOTER //
// ./src/stores/AccountInventoryLocationsUIStore.js